import { useState } from 'react';
import styles from './Preguntas.module.css';

const API_URL =
  process.env.NODE_ENV === 'development'
    ? ''
    : (process.env.REACT_APP_API_URL || '');

export default function Preguntas() {
  const [pregunta, setPregunta] = useState('');
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje({ tipo: '', texto: '' });

    if (!pregunta.trim()) {
      setMensaje({ tipo: 'error', texto: 'Escriba su pregunta.' });
      return;
    }

    let usuario;
    try {
      const stored = localStorage.getItem('usuario');
      usuario = stored ? JSON.parse(stored) : null;
    } catch {
      usuario = null;
    }

    if (!usuario) {
      setMensaje({ tipo: 'error', texto: 'Debe iniciar sesión para enviar preguntas.' });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/preguntas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          pregunta: pregunta.trim(),
          usuario_id: usuario.id,
          nombre_completo: usuario.nombre_completo,
          cedula: usuario.cedula,
        }),
      });

      let data;
      try {
        data = await res.json();
      } catch {
        data = { error: 'Error al procesar la respuesta del servidor.' };
      }

      if (res.ok) {
        setMensaje({ tipo: 'exito', texto: 'Pregunta enviada correctamente. Gracias por participar.' });
        setPregunta('');
        window.dispatchEvent(new CustomEvent('pregunta-nueva'));
      } else {
        setMensaje({ tipo: 'error', texto: data.error || 'Error al enviar la pregunta.' });
      }
    } catch (err) {
      console.error('[Preguntas] Error:', err);
      setMensaje({
        tipo: 'error',
        texto: 'No se pudo conectar con el servidor. Verifique que el servidor esté en ejecución (cd server && npm run dev).',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.preguntas}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <div className={styles.logoWrapper}>
            <div className={styles.logoCircle}>
              <img
                src={`${process.env.PUBLIC_URL}/logo.gif`}
                alt="4to MasterClass EPI"
                className={styles.logoImg}
              />
            </div>
          </div>
          <h1 className={styles.titulo}>Envíe su pregunta</h1>
        </div>
      </section>

      <section className={styles.formSection}>
        <div className={styles.formCard}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.field}>
              <label htmlFor="pregunta">Su pregunta*</label>
              <textarea
                id="pregunta"
                value={pregunta}
                onChange={(e) => setPregunta(e.target.value)}
                placeholder="Escriba aquí su pregunta para los speakers..."
                rows={5}
                required
              />
            </div>
            {mensaje.texto && (
              <p className={mensaje.tipo === 'exito' ? styles.mensajeExito : styles.mensajeError}>
                {mensaje.texto}
              </p>
            )}
            <button type="submit" className={styles.botonEnviar} disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar'}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}
